import React from 'react'
import { ReplyIcon } from './ReplyIcon'

import classes from './ReplyBadge.module.scss'

export const ReplyBadge = () => {
  return (
    <div className={classes.Container}>
      <ReplyIcon />
      <span>Reply</span>
    </div>
  )
}
